import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ff } from '../../../../../../theme';

/** Upload / tray icon for empty top-video slots */
const UploadSlotPlaceholderIcon: React.FC = () => (
  <Flex w="40px" h="40px" borderRadius="full" bg={ff.lime} color={ff.ink} align="center" justify="center" aria-hidden>
    <svg width={18} height={18} viewBox="0 0 20 20" fill="currentColor">
      <path d="M10 2v10M6 6l4-4 4 4" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M3 16h14v2H3v-2z" />
    </svg>
  </Flex>
);

export default UploadSlotPlaceholderIcon;
